import {post} from '../utils/request'


export async function getitemspecprice(data) {
    return await post('api/v1/smartscreen/getitemspecprice',data)
}
